// 用户引导信息获取
import store from '@/store'
import { getGuide } from '@/utils/storage/guide/guide'

/**
 * 获取是否需要进行引导
 * 需要判断以下两个条件
 * 1.判断store中的引导是否开启 开启则需要引导
 * 2.判断是否本次已完成引导 未完成引导则需要进行引导
 * @returns {number|boolean}
 */
export const getIsGuide = function () {
  // guide_on打开且guide标记为假git
  const flag = store.state.userInfo.user.guide_on && !getGuide()
  // return 1
  return flag
}
